import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import CreateIcon from '@material-ui/icons/Create';
import VerticalAlignBottomIcon from '@material-ui/icons/VerticalAlignBottom';
import VerticalAlignTopIcon from '@material-ui/icons/VerticalAlignTop';
import HostFactory from 'commons/handler/HostFactory';

export const API_URL = HostFactory.apiURL;
export const STORAGE_URL = HostFactory.storageURL;
export const STREAMING_URL = HostFactory.streamingURL;
export const DEFAULT_SYMBOLIC_PATH = '/Stroage1';

export const SearchCondition = {
  Asc: {
    DESC: 0,
    ASC: 1,
  },
  Sort: {
    ID: 0,
    DATE_OF_CREATED: 1,
    DATE_OF_MODIFIED: 2,
    TITLE: 3,
    FILE_SIZE: 4,
    DATE_OF_GAME: 5,
    IN_POINT: 6,
    OUT_POINT: 7,
  },
};

export const File = {
  HIRES: 0,
  LOWRES: 1,
  THUMBNAIL: 2,
  SKIM: 3,
  ATTACH: 4,
  SCRIPT: 5,
  PROXY: 41,
};

export const Resolution = {
  HIRES: 0,
  LOWRES: 1,
  PROXY: 41,
};

export const SearchType = {
  SEASON: 'SEASON',
  ETC: 'ETC',
};

export const ViewMode = {
  LIST: true,
  THUMBNAIL: false,
};

export const LIBRARY = {
  REFRESH_SECOND_TIME: 5000,
};

/** 시스템 폴더 */
export const SystemFolder = {
  HIRES_FOLDER_NAME: 'HIRES',
  LOWRES_FOLDER_NAME: 'LOWRES',
  THUMBNAIL_FOLDER_NAME: 'THUMBNAIL',
  SKIM_FOLDER_NAME: 'SKIM',
  ATTACH_FOLDER_NAME: 'ATTACH',
  SCRIPT_FOLDER_NAME: 'SCRIPT',
  LOGO_NAME: 'LOGO',
  PROXY_FOLDER_NAME: 'PROXY',
};

export const AUTHORITIES = {
  DOWNLOAD_LOWRES: 'AUTH_DOWNLOAD_LOWRES',
  EDIT_SHOT: 'AUTH_EDIT_SHOT',
  DOWNLOAD_PARTIAL_HIRES: 'AUTH_DOWNLOAD_PARTIAL_HIRES',
  DOWNLOAD_PARTIAL_LOWRES: 'AUTH_DOWNLOAD_PARTIAL_LOWRES',
  COPY_HIRES_PATH: 'AUTH_USE_NLE',
  STATISTICS_VIEW: 'AUTH_STATS_VIEW',
  AUTH_CLEAN_PARTIAL: 'AUTH_CLEAN_PARTIAL',
  AUTH_EDIT_SCRIPT: 'AUTH_EDIT_SCRIPT',
};

export const SYSTEM_OS = {
  MAC: 'MAC',
  WINDOWS: 'WINDOWS',
};
export const BROWSER = {
  IE11: 'TRIDENT',
  EDGE: 'EDGE',
  CHROME: 'CHROME',
  FIREFOX: 'FIREFOX',
  SAFARI: 'SAFARI',
};

/*
  [아카이브 상태]
    NONE : 아카이브 작업 요청 전
    READY : 아카이브 작업 전
    PROCESSING : 아카이브 작업중
    COMPLETED : 아카이브 작업 완료
    FAILED : 아카이브 작업 실패
*/
export const ARCHIVE_STATUS = {
  NONE: {
    code: 0,
    content: '아카이브 작업 요청 전',
  },
  READY: {
    code: 1,
    content: '아카이브 작업 전',
  },
  PROCESSING: {
    code: 2,
    content: '아카이브 작업 중',
  },
  COMPLETED: {
    code: 3,
    content: '아카이브 작업 완료',
  },
  FAILED: {
    code: -1,
    content: '아카이브 작업 실패',
  },
};

/*
  [리스토어 상태]
    NONE : 리스토어 작업 요청 전
    READY : 리스토어 작업 전
    PROCESSING : 리스토어 작업중
    COMPLETED : 리스토어 작업 완료
    FAILED : 리스토어 작업 실패
 */
export const RESTORE_STATUS = {
  NONE: {
    code: 0,
    content: '리스토어 작업 요청 전',
  },
  READY: {
    code: 1,
    content: '리스토어 작업 전',
  },
  PROCESSING: {
    code: 2,
    content: '리스토어 작업 중',
  },
  COMPLETED: {
    code: 3,
    content: '리스토어 작업 완료',
  },
  FAILED: {
    code: -1,
    content: '리스토어 작업 실패',
  },
};

export const LibraryStatus = {
  FAILURE: -1,
  WAITING: 0,
  PROGRESS: 1,
  SUCCESS: 2,
};

export enum ResolutionEnum {
  LOWRES = 0,
  HIRES = 1,
  PROXY = 41,
}
export enum StatusEnum {
  SUCCESS = 'SUCCESS',
  WAITING = 'WAITING',
  PROCESSING = 'PROCESSING',
  ERROR = 'ERROR',
}

export enum LibraryStatusEnum {
  PROCEED = 'PROCEED',
  WAITING = 'WAITING',
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
}

type LibraryStatusTextType = {
  [key: string]: string;
};

export const LibraryStatusText: LibraryStatusTextType = {
  PROCEED: '진행 중',
  WAITING: '대기 중',
  SUCCESS: '완료',
  FAILURE: '실패',
};

export const AvailableDownloadStatus = {
  NOT_DOWNLOADABLE: 0,
  DOWNLOADABLE: 1,
};

export const CODE_NAME = {
  VIDEO_TYPE: '영상타입',
  GAME_STATE: '경기상태',
  GAME_TYPE: '경기타입',
  LEAGUE_TYPE: '리그타입',
};

export const EVENT_LOG_STYLE = {
  HEIGHT: 80,
};

export const METASCHEMA = {
  TYPE: {
    STRING: 'STRING',
    BOOLEAN: 'BOOL',
    NUMBER: 'NUMBER',
    DATE: 'DATE',
  },
};

export const Storage = {
  MAIN: 'Main',
  BACKUP: 'Backup',
};

export const PageReturnCountOptions = [
  { value: 12, name: '12개' },
  { value: 24, name: '24개' },
  { value: 48, name: '48개' },
];

export const SortOptions = [
  {
    value: SearchCondition.Sort.DATE_OF_GAME,
    name: '경기 일자',
    icon: CalendarTodayIcon,
  },
  { value: SearchCondition.Sort.TITLE, name: '콘텐츠 명', icon: CreateIcon },
];

export const SortOptionsByLibrary = [
  {
    value: SearchCondition.Sort.DATE_OF_CREATED,
    name: '생성일',
    icon: CalendarTodayIcon,
  },
  { value: SearchCondition.Sort.TITLE, name: '콘텐츠 명', icon: CreateIcon },
];

export const OrderByOptions = [
  {
    value: SearchCondition.Asc.DESC,
    name: '내림차순',
    icon: VerticalAlignBottomIcon,
  },
  {
    value: SearchCondition.Asc.ASC,
    name: '오름차순',
    icon: VerticalAlignTopIcon,
  },
];

export const ScriptOptions = [
  { id: 'shoot', value: '2점,3점슛', name: '2점/3점슛' },
  { id: 'rebound', value: '리바운드', name: '리바운드' },
  { id: 'assist', value: '어시스트', name: '어시스트' },
  { id: 'steal', value: '스틸', name: '스틸' },
  { id: 'block', value: '블록', name: '블록' },
  { id: 'freeThrow', value: '자유투', name: '자유투' },
  { id: 'videoAssistantReferee', value: '비디오판독', name: '비디오판독' },
];

export const RangeOptions = [
  {
    id: 'HIGHLIGHT',
    value: 'HIGHLIGHT',
    name: '하이라이트',
  },
  {
    id: 'INTERVIEW',
    value: 'INTERVIEW',
    name: '인터뷰',
  },
];

export const CodeValue = {
  KF_SCRIPT_TYPE: 'KF_SCRIPT_TYPE',
  KF_SCRIPT_REF_RANGE: 'KF_SCRIPT_REF_RANGE',
  VIDEO_TYPE: 'VIDEO_TYPE',
  WKBL_SEASON: 'WKBL_SEASON',
  WKBL_GAME_TYPE: 'WKBL_GAME_TYPE',
};

export const Preferences = {
  groupNames: {
    VIDEO: 'VIDEO',
    VIDEO_LIBRARY: 'VIDEO_LIBRARY',
    BANNER: 'BANNER',
  },
  fieldNames: {
    VIDEO_LIBRARY_MAX_REQUEST_COUNT_BY_USER: 'VIDEO_LIBRARY_MAX_REQUEST_COUNT_BY_USER',
    VIDEO_PARTIAL_MIN_TIME: 'VIDEO_PARTIAL_MIN_TIME',
    VIDEO_PARTIAL_MAX_TIME: 'VIDEO_PARTIAL_MAX_TIME',
    WEB_BANNER_FILE_PATH: 'WEB_BANNER_FILE_PATH',
    MOBILE_BANNER_FILE_PATH: 'MOBILE_BANNER_FILE_PATH',
    USE_BANNER: 'USE_BANNER',
  },
};

export const style = {
  PINK_COLOR: '#d94f98',
  PINK_COLOR_DARKER: '#9f2365',
  PINK_COLOR_DARKER_HOVER: '#7f1b4f',
  SCRIPT_DIVIDER_BORDER: '#2a303d',
  PREVIEW_BACKGROUND_COLOR: '#000817',
  PREVIEW_CONTENTS_BACKGROUND_COLOR: '#121927',
};

export const VideoPlayMode = {
  SECTION_PLAY: true,
  NORMAL_PLAY: false,
};

export const TimeButton = {
  timeType: {
    IN_HOUR: 'IN_HOUR',
    IN_MINUTE: 'IN_MINUTE',
    IN_SECOND: 'IN_SECOND',
    OUT_HOUR: 'OUT_HOUR',
    OUT_MINUTE: 'OUT_MINUTE',
    OUT_SECOND: 'OUT_SECOND',
  },
};

export const BannerStatus = {
  UNAVAILABLE: 0,
  AVAILABLE: 1,
};

export const VideoInOutPointIconWidth = 15;

export const Auth = {
  ACCESS_TOKEN: 'accessToken',
  USER_ID: 'userId',
  USER_NAME: 'userName',
  AUTHORITIES: 'authorities',
};

export const WKBLVideoContentsType = {
  VIDEO: 'VIDEO',
  SCRIPT: 'SCRIPT',
};

export const MoveToDownloadPageDelay = 500;
